export enum ThemeColor {
  black = '#000000',
  white = '#ffffff'
}

export const BASE_TITLE = 'the escalated publisher';
export const BASE_URL = 'https://the-escalated-publisher.at/';
export const BASE_IMAGE_URL = `${BASE_URL}assets/kanten.png`
